import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BaseURL from "../../BaseURL/BaseURL";
import { TailSpin } from "react-loader-spinner";

const Contact = () => {
  const [loader, setLoader] = useState(false);
  const [, setApi] = useState([]);
  const [queries, setQueries] = useState("");
  const [Subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  // const id = localStorage.getItem("id");
  // const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const contact = () => {
    setLoader(true);

    const data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("subject", Subject);
    data.append("queries", queries);
    try {
      var config = {
        method: "POST",
        url: `${BaseURL.baseurl}/contact`,
        data: data,
        headers: {
          Accept: "application/json",
          // Authorization: `Bearer ${token}`,
        },
      };

      axios(config)
        .then(function (response) {
          setLoader(false);
          console.log(response, "api");
          setApi(response.data.data);
          if(response.data.status === true){
            Swal.fire({
              title: response.data.response,
              text: "Email Sent Successfully",
              icon: "success",
              dangerMode: true,
            });
            navigate('/');
          }else{
            Swal.fire({
              title: "Something Went Wrong",
              text: "check your Details",
              icon: "error",
              dangerMode: true,
            });
          }
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  return (
    <>
      <Header />

      <div class="container margin_60_35">
        <div class="row">
          <aside class="col-lg-3 col-md-4">
            <div id="contact_info">
              <h3>Contacts info</h3>
              <p>
                11 Fifth Ave - New York, US
                <br /> + 61 (2) 8093 3400
                <br />
                {/* <a href="#">info@domain.com</a> */}
              </p>

              <ul>
                <li>
                  <strong>Administration</strong>
                  <a href="tel://003823932342">0038 23932342</a>
                  <br />
                  <a href="tel://003823932342">admin@Dentective.com</a>
                  <br />
                  <small>Monday to Friday 9am - 7pm</small>
                </li>
                <li>
                  <strong>General questions</strong>
                  <a href="tel://003823932342">0038 23932342</a>
                  <br />
                  <a href="tel://003823932342">questions@Dentective.com</a>
                  <br />
                  <p>
                    <small>Monday to Friday 9am - 7pm</small>
                  </p>
                </li>
              </ul>
            </div>
          </aside>
          {/* <!--/aside --> */}
          <div class=" col-lg-8 col-md-8 ml-auto">
            <div class="box_general">
            <h1 className="text-center">Contacts Us</h1>
              <div>
                <div id="message-contact"></div>
                <form>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <div class="form-group">
                        <input
                          type="text"
                          id="email_contact"
                          name="email_contact"
                          class="form-control"
                          placeholder="Name"
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div class="form-group">
                        <input
                          type="email"
                          id="email_contact"
                          name="email_contact"
                          class="form-control"
                          placeholder="email"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-sm-12">
                      <div class="form-group">
                        <input
                          type="text"
                          id="email_contact"
                          name="email_contact"
                          class="form-control"
                          placeholder="Subject"
                          onChange={(e) => setSubject(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <textarea
                          rows="5"
                          id="message_contact"
                          name="message_contact"
                          class="form-control"
                          style={{ height: "100px" }}
                          placeholder="message"
                          onChange={(e) => setQueries(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <button type="button" class="btn-theme" onClick={contact}>
                  {loader === true ? (
                    <TailSpin
                      height="30"
                      width="30"
                      color="#4fa94d"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
              {/* <!-- /col --> */}
            </div>
          </div>
          {/* <!-- /col --> */}
        </div>
        {/* <!-- End row --> */}
      </div>
      <Footer />
    </>
  );
};

export default Contact;
